<template>
  <div>
    <div
      class="va-row"
      :class="plans.length < 4 ? 'align--center justify--center' : ''"
    >
      <div v-for="plan in plans" :key="plan.plan_id" class="flex md3 sm6 xs12">
        <vuestic-card class="text-center features-card">
          <template slot="title" class="feature-title">
            {{ plan.name }} <br />
            <span>{{ plan.package_type.name }}</span>
          </template>
          <p>{{ plan.description }}</p>
          <ul class="features-list" v-if="plan.package_type.id === 1">
            <li>
              <span class="text-light">{{ plan.ring_Group }}</span>
              Ring Groups
            </li>
            <li>
              <span class="text-light">{{ plan.ivr }}</span> IVRs
            </li>
            <li>
              <span class="text-light">{{ plan.ext }}</span>
              Extensions
            </li>
            <li>
              <i class="fa fa-check text-light" v-if="plan.queue"></i>
              <i class="fa fa-times text-danger" v-else></i>
              Queue
            </li>
            <li>
              <i class="fa fa-check text-light" v-if="plan.conference"></i>
              <i class="fa fa-times text-danger" v-else></i>
              Conference
            </li>
            <li>
              <i class="fa fa-check text-light" v-if="plan.statistics"></i>
              <i class="fa fa-times text-danger" v-else></i>
              Statistics
            </li>
            <li>
              <i class="fa fa-check text-light" v-if="plan.outbound_calls"></i>
              <i class="fa fa-times text-danger" v-else></i>
              Outbound Calls
            </li>
            <li>
              <i class="fa fa-check text-light" v-if="plan.pbxPortal"></i>
              <i class="fa fa-times text-danger" v-else></i>
              PbxPortal
            </li>
          </ul>
          <ul class="features-list" v-if="plan.package_type.id === 2">
            <li>
              <span class="text-light">{{ plan.concurrent_calls }}</span>
              Concurrent Calls
            </li>
            <li v-if="!plan.unlimited_incoming_minutes">
              <span class="text-light">{{ plan.free_incoming_minutes }}</span>
              Incoming Minutes
            </li>
            <li v-if="plan.unlimited_incoming_minutes">
              <i
                class="fa fa-check text-light"
                v-if="plan.unlimited_incoming_minutes"
              ></i>
              <i class="fa fa-times text-danger" v-else></i>
              Unlimited Incoming Minutes
            </li>
            <li v-if="!plan.unlimited_out_pound_minutes">
              <span class="text-light">
                {{ plan.free_out_pound_minutes }}
              </span>
              Outbound Minutes
            </li>
            <li v-if="plan.unlimited_out_pound_minutes">
              <i
                class="fa fa-check text-light"
                v-if="plan.unlimited_out_pound_minutes"
              ></i>
              <i class="fa fa-times text-danger" v-else></i>
              Unlimited Outbound Minutes
            </li>
            <li>
              <span class="text-light">{{ plan.incoming_minutes_rate }}</span>
              Incoming Minutes Rate
            </li>
            <li>{{ plan.city_name }}</li>
          </ul>
          <div v-if="plan.package_type.id === 3">
            <span class="text-info"><em>Packages Included</em></span>
            <ul class="features-list">
              <li
                v-for="bundlePackage in plan.BundlePackages"
                :key="bundlePackage.uuid"
                v-popover.left="{ name: 'package-popover' }"
                class="popover-toggle"
                @click="setPopoverPackage(bundlePackage.uuid)"
              >
                {{ bundlePackage.name }}
              </li>
            </ul>
          </div>
          <span class="phone-input-toggle" @click="showNumbers(plan.uuid)"
            >Select Phone Numbers</span
          >
          <vuestic-multi-select
            v-show="numbersShown.id === plan.uuid && numbersShown.state"
            v-model="phones"
            :options="phoneNumbers"
            :optionKey="'phone_number'"
            :name="'phone_number'"
            class="w-75 mx-auto"
          />
          <button
            class="btn btn-block text-center"
            :class="{ loading: loading.state === true }"
            @click="confirmSubscription(plan)"
          >
            <span v-if="loading.state === false">
              {{ $t('buttons.subscribe') }}
            </span>
            <spring-spinner
              v-if="loading.id === plan.plan_id && loading.state === true"
              slot="loading"
              :animation-duration="2500"
              :size="30"
              color="#94c120"
              class="mx-auto"
            />
          </button>
        </vuestic-card>

        <Popover name="package-popover">
          <PackagePopover :plan="popoverPlan" :type="popoverPlanType" />
        </Popover>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import Popover from 'vue-js-popover'
import SpringSpinner from 'epic-spinners/src/components/lib/SpringSpinner'
import PackagePopover from './helpers/package-popover'

Vue.use(Popover)

export default {
  components: {
    SpringSpinner,
    PackagePopover
  },
  data() {
    return {
      popoverPlan: [],
      popoverPlanType: 1,
      phones: [],
      loading: {
        id: 0,
        state: false
      },
      numbersShown: {
        id: 0,
        state: false
      }
    }
  },
  computed: {
    ...mapGetters(['plans', 'phoneNumbers'])
  },
  methods: {
    ...mapActions(['fetchPlans', 'subscribeToPackage', 'fetchNumbers']),
    async confirmSubscription(plan) {
      let name = plan.name
      this.$swal({
        title: `Confirm Subscription`,
        html: `Do you want to subscribe to <b><em>${name}</em></b>?`,
        showCancelButton: true,
        confirmButtonText: 'Subscribe',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary btn-sm',
          cancelButton: ' btn btn-dark btn-sm mx-2'
        },
        buttonsStyling: false
      }).then(res => {
        if (res.value) {
          this.subscribe(plan.plan_id)
        }
      })
    },
    async subscribe(plan_id) {
      this.loading = {
        id: plan_id,
        state: true
      }
      let phoneUUIDs = this.phones.map(phone => phone.id)
      const res = await this.subscribeToPackage({
        id: plan_id,
        phones: phoneUUIDs
      })
      this.loading.state = false
      if (res.data.success) {
        this.$toasted.show(res.data.data.message, {
          icon: 'fa-check-circle',
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })
        this.phones = []
        this.fetchNumbers()
      }
    },
    setPopoverPackage(uuid) {
      this.plans.forEach(plan => {
        if (plan.uuid === uuid) {
          this.popoverPlan = plan
          this.popoverPlanType = plan.package_type.id
        }
      })
    },
    showNumbers(id) {
      if (id === this.numbersShown.id) {
        this.numbersShown.state = !this.numbersShown.state
      } else {
        this.phones = []
        this.numbersShown = {
          id,
          state: true
        }
      }
    }
  },
  created() {
    if (this.plans.length === 0) {
      this.fetchPlans()
    }
    if (this.fetchNumbers.length === 0) {
      this.fetchNumbers()
    }
  }
}
</script>
<style lang="scss">
.features-card {
  border-top: $main-dark solid 0.5rem;
  transition: all 0.2s ease;
  overflow: hidden;
  .card-body {
    padding: 0 !important;
  }
  .card-title {
    background-color: $main-dark;
    margin-top: 0 !important;
    padding: 1rem;
    color: $main-light;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span {
      font-size: 14px;
      color: $white;
      font-weight: bold !important;
    }
  }
  .card-text {
    display: flex;
    flex-direction: column;
    min-height: 450px;
  }
  button {
    border-radius: 0 !important;
    color: $main-light;
    box-shadow: none !important;
    border-bottom-right-radius: $widget-border-radius !important;
    border-bottom-left-radius: $widget-border-radius !important;
  }
  &:hover {
    border-top: $main-light solid 0.5rem;
    max-height: unset;
    overflow: unset;
    .card-title {
      text-overflow: unset;
      white-space: unset;
    }
    button:not(.loading) {
      background-color: $main-light;
      color: $white;
    }
  }
}

.features-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
  li {
    padding: 7px 15px;
    color: $main-dark;
    line-height: 26px;
    span,
    i {
      font-size: 18px;
    }
  }
  li:nth-child(odd) {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.popover-toggle:hover {
  cursor: pointer;
  background-color: $main-light !important;
  color: $white;
}
div[data-popover='package-popover'] {
  font-size: 14px;
  min-width: 300px;
}
.phone-input-toggle {
  color: $brand-info;
  cursor: pointer;
  font-size: 13px;
  margin-top: auto;
}
</style>
